var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_SDK_ic",
    "data-name": "Download SDK_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.394,
    height: 14.372,
    viewBox: "0 0 16.394 14.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M78.007,122.752v-7.726l-6.089-2.111-6.089,2.111v7.726l6.089,1.931Z",
    transform: "translate(-63.721 -110.311)",
    fill: "#fd982c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M262.078,122.752v-7.726l-6.089-2.111v11.768Z",
    transform: "translate(-247.792 -110.311)",
    fill: "#fa502e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M78.007,115.026l-6.089-2.111-6.089,2.111,6.089,2.142Z",
    transform: "translate(-63.721 -110.311)",
    fill: "#fff2b4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M262.078,115.026l-6.089-2.111v4.253Z",
    transform: "translate(-247.792 -110.311)",
    fill: "#ffdf8e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0 4.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M2.108,178.826,0,181.32l6.2,2.254L8.2,180.968Z",
    transform: "translate(0 -178.826)",
    fill: "#fabe3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M262.078,178.826l2.109,2.494-6.2,2.254-1.994-2.606Z",
    transform: "translate(-247.792 -178.826)",
    fill: "#fabe3d"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M262.078,178.826l2.109,2.494-6.2,2.254-1.994-2.606Z",
    transform: "translate(-247.792 -174.111)",
    fill: "#fd982c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M2.108,36.294,0,33.833l6.2-2.254,1.993,2.6Z",
    transform: "translate(0 -31.579)",
    fill: "#fdda50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M262.078,36.294l2.109-2.46-6.2-2.254-1.994,2.6Z",
    transform: "translate(-247.792 -31.579)",
    fill: "#fabe3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSdk);
export default __webpack_public_path__ + "static/media/DownloadSDK.5731bd47.svg";
export { ForwardRef as ReactComponent };